if (typeof Things == 'undefined') Things = {
    contextRoot: '/things'
};
"use strict";

Things.Product = Backbone.Model.extend({
    urlRoot: Things.contextRoot + '/product',

    getVariableDescription: function(name) {
        return _(this.get('variables')).findWhere({name: name});
    },
    getThumbnailUrl: function() {
        var url = this.get('thumbnail');
        if (url && url.indexOf('/') != 0 && url.indexOf('http') != 0)
            url = Things.contextRoot + '/images/thumbnails/' + url;
        return url;
    },

    // Some product specific stuff below

    getThresoldConfigurationForVariable: function(variableName) {
        switch (this.id) {
            case 'CDN-CS':
                if (variableName == 'I0') return 'threshold0';
                break;
        }
    },
});

Things.Products = Backbone.Collection.extend({
    model: Things.Product,
    url: Things.contextRoot + '/product',
});

Things.products = new Things.Products();
Things.products.setCacheOptions({key: 'things_products', store: 'local'});
